import { render, staticRenderFns } from "./goodsNo.vue?vue&type=template&id=31048e76&scoped=true&"
import script from "./goodsNo.vue?vue&type=script&lang=js&"
export * from "./goodsNo.vue?vue&type=script&lang=js&"
import style0 from "./goodsNo.vue?vue&type=style&index=0&id=31048e76&lang=less&scoped=true&"
import style1 from "./goodsNo.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31048e76",
  null
  
)

export default component.exports